<template>
    <v-app id="app" class="app-body" style="position:relative;">
        <v-overlay :value="loading" absolute opacity="0"></v-overlay>

        <v-snackbar
            v-model  = "showMessage"
            :color   = "color"
            :timeout = "timeout"
            class    = "stored"
        >
            {{ message }}

            <template v-slot:action="{ attrs }">
                <a
                    v-if   = "closeSnackbar"
                    v-bind = "attrs"
                    @click = "showMessage = false"
                >
                    <v-icon>mdi-close</v-icon>
                </a>
            </template>
        </v-snackbar>

        <d-app-message
            v-model  = "showMessageDialog"
            :message = "messageRessource"
        />

        <d-app-confirm
            v-model  = "confirm.show"
            :text    = "confirm.query"
            :subtext = "confirm.text"
            :width   = "confirm.width"
            :spinner = "confirm.spinner"
            @confirm = "onConfirmX"
        />

        <c-dms-dragable-viewer

        />

        <img-upload-panel />

        <div class="loading-bar" v-if="loading" style="z-index: 500">
            <div class="mb-1 primary--text">
                {{ loadingMessage ? loadingMessage : $t('common.loading') }}
            </div>
            <v-progress-linear
                indeterminate
                color="primary"
                height="10"
            ></v-progress-linear>
        </div>

        <c-app-memory
            v-if  = "showMemoryGadget"
            class = "memory-info"
        />

        <router-view style="margin-top: 2px;" v-if="initialized"></router-view>
    </v-app>
</template>

<script>
import Core               from "@/modules/core/service/Core";
import { store }          from "@/modules/core/store.js"
import DAppMessage        from "@/modules/core/components/app/DAppMessage";
import DAppConfirm        from "@/modules/core/components/app/DAppConfirm";
import CDmsDragableViewer from "@/modules/dms/viewer/CDmsDragableViewer.vue";
import ImgUploadPanel     from "@/modules/img/components/main/ImgUploadPanel.vue";
import CAppMemory         from "@/modules/core/components/app/CAppMemory.vue";
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
    components: {
        CAppMemory,
        CDmsDragableViewer,
        ImgUploadPanel,
        DAppConfirm,
        DAppMessage,
    },

    store,
    name   : 'App',

    data: () => ({
        loading          : false,
        loadingMessage   : null,
        showMessage      : false,
        message          : null,
        showMessageDialog: false,
        messageRessource : null,
        color            : "primary",
        timeout          : 2000,
        closeSnackbar    : false,
        startup          : true,
        initialized      : false,
        confirm: {
            show    : false,
            query   : null,
            text    : null,
            spinner : false,
            callback: null
        }
    }),

    computed: {
        preferences () {
            return this.$store.getters.preferences;
        },

        showMemoryGadget () {
            if (!this.preferences) {
                return null;
            }

            return this.preferences['memorygadget'];
        }
    },

    created() {
        this.$bus.$on(this.$events.alert.confirm, (data) => {
            this.confirm.show     = true;
            this.confirm.query    = data.query;
            this.confirm.text     = data.text;
            this.confirm.callback = data.callback;
            this.confirm.width    = data.width ? data.width : 450;
        })

        this.$bus.$on(this.$events.alert.message, (data) => {
            this.showSnackbar (data, "primary");
        })

        this.$bus.$on(this.$events.alert.error, (data) => {
            this.showSnackbar (data, "error");
        })

        this.$bus.$on(this.$events.alert.warning, (data) => {
            this.showSnackbar (data, "warning");
        })

        this.$bus.$on(this.$events.message, (data) => {
            this.messageRessource = data;
            this.showMessageDialog = true;
        })

        this.$bus.$on(this.$events.loading, (value) => {
            this.loadingMessage = value.message;
            this.loading = value.value;
        })
    },

    mounted() {
        // noinspection JSUnresolvedFunction
        GoogleMapsApiLoader({
            apiKey: "AIzaSyBRyBpoi2NNoKq8Uxhz848-cacin-2E7NU"
        }).then ((x) => window.mgoogle = x);

        Core.init.load(this.$store, true).then(() => {
            this.loadTheme();
            this.initialized = true;
 //           this.$router.replace({'query': null});
        });
    },

    methods: {
        loadTheme () {
            const themes = this.$store.getters.themes;
            const name  = this.$store.getters.preferences.theme;

            let theme  = themes.find(t => t.name === name);
            if (!theme) {
                theme = themes.find(t => t.name === 'Standard');
            }

            this.$vuetify.theme.themes.light.primary = theme.primary;
        },

        showSnackbar (data, color) {
            this.message       = data.message;
            this.color         = color;
            this.showMessage   = true;
            this.timeout       = data.close ? 10000 : 2000;
            this.closeSnackbar = data.close;
        },

        onConfirmX (value) {
            if (this.confirm.callback) {
                this.confirm.callback(value);
                this.confirm.spinner = false;
                this.confirm.show = false;
            } else {
                this.confirm.show = false;
            }
        }
    }
}
</script>

<style scoped>

.app-body {
    margin-left: 0;
    margin-right: 0;
}

.memory-info {
    position: absolute;
    left: 17px;
    top: 14px;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    text-orientation: sideways;
}

</style>

<!-- Global styles imported here to ensure Vite processes them -->
<style lang="scss">
@use '@/assets/sass/global.scss';
</style>


<style lang="scss" scoped>

.loading-bar {
    position: absolute;
    z-index: 100;
    width: 400px;
    height: 80px;
    top: 65px;
    left: calc(50% - 200px);
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 15px;
    background-color: white;
    font-size: 15px;

    border-width: 2px;
    border-style: solid;
    border-color: var(--v-primary-base);
    border-radius: 5px;
}

</style>
